import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  complete: false,
  step: 1,
  data: null,
}

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setOnboardingComplete: (state, action) => {
      state.complete = action.payload
    },
    setOnboardingStep: (state, action) => {
      state.step = action.payload
    },
    setOnboardingData: (state, action) => {
      state.data = action.payload
    },
    resetOnboarding: (state) => {
      return initialState
    },
  },
})

export const { setOnboardingComplete, setOnboardingStep, setOnboardingData, resetOnboarding } =
  onboardingSlice.actions

export default onboardingSlice.reducer
